export const OptionType = Object.freeze({
    industry: "industry",
    product: "product",
});
